import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';

export default class Compras {
    static typeSearch = "local" //online || local
    static rules = {
        Requerido: [(value) => !!value || 'El campo obligatorio'],
    }

    static statusList =  [
      {id:"P", name:"Pendiente"},
      {id:"A", name:"Aplicado"},
      {id:"F", name:"Finalizado"},
      /*{id:"Producto-SSal",name:"Producto de solo salidas"}*/
    ]

    static types = [
      {id:"A", name:"Abierta"},
      {id:"O", name:"Desde orden de compra"},
    ]
    constructor(data = null) {
        this.Id = (data?.id) ? data.id : null;
        this.sts = (data?.sts) ? data.sts : "P";
        this.amc = (data?.amc) ? data.amc : "";
        this.mmt = (data?.mmt) ? data?.mmt: '';
        this.ocm = (data?.ocm)? data?.ocm:null;
        this.dsc = (data?.dsc) ? data?.dsc: '';
        this.Tenant = (data?.Tenant) ? data.Tenant : store.getters.getFirebaseApp.tenant;
        this.adq = (data?.adq) ? data.adq : []
        this.dpt = (data?.dpt) ? data.dpt : null
    }



    static getPropertyModel() {
        return this;
    }

    static getStatusList(){
      return this.statusList;
    }

    static getTypes(){
      return this.types;
    }

    static async getOrdeneCompra() {

        const firestore = store.getters.getFirebaseApp.firestore
        const data = await firestore
            .queryBuilder("AMC_Presentaciones",
                [
                ]
            )
        if (data.empty) {
            return [];
        } else {
            let doc = data.docs.map(doc => { return { Id: doc.ref.id, ...doc.data() } });
            return doc;
        }
    }
    static getRules() {
        return this.rules;
    }



}